import { H as e, I as t, U as n, _ as r, v as i, z as a } from "./useCollections-BPbWcv6t.js";
import { config as o } from "lib-shared-backend-config";
import * as s from "react";
import { useState as c } from "react";
//#region ../delivery-common/src/hooks/useDeliveryLanguages.ts
function l({ selectedLanguageId: e, onCompleted: n, fetchPolicy: r = "cache-first" } = {}) {
	let { data: i, ...a } = t({
		fetchPolicy: r,
		onCompleted: n
	});
	return {
		...a,
		data: u(i, e)
	};
}
function u(e, t) {
	if (!e?.organisationSettings) return;
	let n = e.organisationSettings.enabledLanguages.find((e) => e.languageId === t) || e.organisationSettings.defaultLanguage;
	return {
		...e.organisationSettings,
		selectedLanguage: n
	};
}
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/serialize.js
var d = (/* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.path = void 0;
	function t(e) {
		let a = n(e), o = (e) => "/" + a.map((t) => t.kind === "param" ? i(e, t.paramName) : t.value).filter((e) => e !== "").join("/");
		if (o.pattern = r(e), o.parts = a, o.path = (n) => t(`${e}/${n}`), !o.pattern.startsWith("/")) throw Error(`Paths must begin with slashes, but ${JSON.stringify(o.pattern)} doesn't.`);
		return o;
	}
	e.path = t;
	function n(e) {
		return e.split("/").map((e) => e.startsWith(":") ? {
			kind: "param",
			paramName: e.replace(/^:/, "")
		} : {
			kind: "constant",
			value: e
		});
	}
	function r(e) {
		return e === "/" ? e : e.replace(/\/+/g, "/").replace(/^(.+)\/$/, (e, t) => t);
	}
	function i(e, t) {
		let n = e[t];
		if (typeof n != "string") throw Error(`When generating a path, the path param ${JSON.stringify(t)} didn't exist on params object ${JSON.stringify(e)}. The types should have prevented this, so either you defeated them (e.g., with \`as\`) or this is a bug!`);
		return n;
	}
})))();
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/objectToSearchString.js
function f(e) {
	let t = new URLSearchParams(), n = Object.entries(e);
	for (let [e, r] of n) if (r != null) if (Array.isArray(r)) for (let n of r) t.append(e, n ?? "");
	else t.append(e, r);
	return t.toString();
}
"{}[],\":".split("").map((e) => [e, encodeURIComponent(e)]);
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/searchStringToObject.js
function p(e) {
	let t = new URLSearchParams(e), n = {};
	for (let [e, r] of t) Object.prototype.hasOwnProperty.call(n, e) ? Array.isArray(n[e]) ? n[e].push(r) : n[e] = [n[e], r] : n[e] = r;
	return n;
}
new class {
	constructor() {
		this.paramsMap = /* @__PURE__ */ new Map(), this.registeredParams = /* @__PURE__ */ new Map();
	}
	set(e, t, n, r) {
		this.paramsMap.set(e, {
			stringified: t,
			decoded: n,
			decode: r
		});
	}
	has(e, t, n) {
		if (!this.paramsMap.has(e)) return !1;
		let r = this.paramsMap.get(e);
		return r ? r.stringified === t && (n == null || r.decode === n) : !1;
	}
	get(e) {
		if (this.paramsMap.has(e)) return this.paramsMap.get(e)?.decoded;
	}
	registerParams(e) {
		for (let t of e) {
			let e = this.registeredParams.get(t) || 0;
			this.registeredParams.set(t, e + 1);
		}
	}
	unregisterParams(e) {
		for (let t of e) {
			let e = (this.registeredParams.get(t) || 0) - 1;
			e <= 0 ? (this.registeredParams.delete(t), this.paramsMap.has(t) && this.paramsMap.delete(t)) : this.registeredParams.set(t, e);
		}
	}
	clear() {
		this.paramsMap.clear(), this.registeredParams.clear();
	}
}();
//#endregion
//#region ../../../node_modules/use-query-params/dist/QueryParamProvider.js
var m = {
	adapter: {},
	options: {
		searchStringToObject: p,
		objectToSearchString: f,
		updateType: "pushIn",
		includeKnownParams: void 0,
		includeAllParams: !1,
		removeDefaultsFromUrl: !1,
		enableBatching: !1,
		skipUpdateWhenNoChange: !0
	}
};
s.createContext(m);
//#endregion
//#region ../utils/src/routes.ts
var h = (0, d.path)("/knowledge"), g = h.path("/collection"), _ = h.path("/collection/:collectionId"), v = h.path("/settings"), y = h.path("/article-editor/:articleId"), b = y.path("/version-history"), x = h.path("/articles"), S = h.path("/article-suggestions"), C = (0, d.path)("/internal-kb"), w = C.path("/collection/:collectionId"), T = C.path("/collection/:collectionId/article/:articleId"), E = (0, d.path)("/settings").path("/help-centers"), D = E.path("/:helpCenterId"), O = {
	content: () => g({}),
	articleSuggestions: () => S({}),
	articles: (e) => e?.length ? `${x({})}?${e}` : x({}),
	collectionEdit: ({ collectionId: e, articlesFiltersStore: t }) => {
		let { collectionId: n, ...r } = t, i = f(r);
		return i.length ? `${_({ collectionId: e })}?${i}` : _({ collectionId: e });
	},
	articleVersionHistory: ({ articleId: e, languageId: t }) => {
		let n = b({ articleId: e });
		return t ? `${n}?langId=${t}` : n;
	},
	articleEdit: ({ articleId: e, collectionId: t, languageId: n }) => {
		let r = {};
		n && (r.langId = n), t && (r.collectionId = t);
		let i = Object.keys(r).length > 0 ? new URLSearchParams(r).toString() : "";
		return `${y({ articleId: e })}${i.length ? `?${i}` : ""}`;
	},
	knowledgeSettingsPath: () => v({}),
	internalKBDashboard: () => C({}),
	internalKBCollection: ({ collectionId: e }) => w({ collectionId: e }),
	internalKBArticle: ({ collectionId: e, articleId: t, languageId: n }) => ({
		path: T({
			collectionId: e,
			articleId: t
		}),
		search: `langId=${n}`
	}),
	helpCentersPath: () => E({}),
	helpCenterSettingsPath: ({ helpCenterId: e }) => D({ helpCenterId: e })
};
//#endregion
//#region ../utils/src/hooks/useRestPost.ts
function k({ url: e, options: t = {
	withAuth: !0,
	headers: {}
} }) {
	let [n, r] = c(!1), [i, o] = c(null), [s, l] = c(null);
	return [async (n) => {
		let i = await a(), s = {
			"Content-Type": "application/json",
			...t.withAuth ? { Authorization: i } : {},
			...t.headers
		};
		r(!0), l(null), o(null);
		try {
			let t = await fetch(e, {
				method: "POST",
				headers: s,
				body: JSON.stringify(n)
			});
			if (!t.ok) throw Error("Failed to fetch data");
			let r = await t.json();
			return l(r), r;
		} finally {
			r(!1);
		}
	}, {
		loading: n,
		error: i,
		data: s
	}];
}
//#endregion
//#region ../../../node_modules/retry/lib/retry_operation.js
var A = /* @__PURE__ */ e(((e, t) => {
	function n(e, t) {
		typeof t == "boolean" && (t = { forever: t }), this._originalTimeouts = JSON.parse(JSON.stringify(e)), this._timeouts = e, this._options = t || {}, this._maxRetryTime = t && t.maxRetryTime || Infinity, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._operationStart = null, this._timer = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
	}
	t.exports = n, n.prototype.reset = function() {
		this._attempts = 1, this._timeouts = this._originalTimeouts.slice(0);
	}, n.prototype.stop = function() {
		this._timeout && clearTimeout(this._timeout), this._timer && clearTimeout(this._timer), this._timeouts = [], this._cachedTimeouts = null;
	}, n.prototype.retry = function(e) {
		if (this._timeout && clearTimeout(this._timeout), !e) return !1;
		var t = (/* @__PURE__ */ new Date()).getTime();
		if (e && t - this._operationStart >= this._maxRetryTime) return this._errors.push(e), this._errors.unshift(/* @__PURE__ */ Error("RetryOperation timeout occurred")), !1;
		this._errors.push(e);
		var n = this._timeouts.shift();
		if (n === void 0) if (this._cachedTimeouts) this._errors.splice(0, this._errors.length - 1), n = this._cachedTimeouts.slice(-1);
		else return !1;
		var r = this;
		return this._timer = setTimeout(function() {
			r._attempts++, r._operationTimeoutCb && (r._timeout = setTimeout(function() {
				r._operationTimeoutCb(r._attempts);
			}, r._operationTimeout), r._options.unref && r._timeout.unref()), r._fn(r._attempts);
		}, n), this._options.unref && this._timer.unref(), !0;
	}, n.prototype.attempt = function(e, t) {
		this._fn = e, t && (t.timeout && (this._operationTimeout = t.timeout), t.cb && (this._operationTimeoutCb = t.cb));
		var n = this;
		this._operationTimeoutCb && (this._timeout = setTimeout(function() {
			n._operationTimeoutCb();
		}, n._operationTimeout)), this._operationStart = (/* @__PURE__ */ new Date()).getTime(), this._fn(this._attempts);
	}, n.prototype.try = function(e) {
		console.log("Using RetryOperation.try() is deprecated"), this.attempt(e);
	}, n.prototype.start = function(e) {
		console.log("Using RetryOperation.start() is deprecated"), this.attempt(e);
	}, n.prototype.start = n.prototype.try, n.prototype.errors = function() {
		return this._errors;
	}, n.prototype.attempts = function() {
		return this._attempts;
	}, n.prototype.mainError = function() {
		if (this._errors.length === 0) return null;
		for (var e = {}, t = null, n = 0, r = 0; r < this._errors.length; r++) {
			var i = this._errors[r], a = i.message, o = (e[a] || 0) + 1;
			e[a] = o, o >= n && (t = i, n = o);
		}
		return t;
	};
})), j = /* @__PURE__ */ e(((e) => {
	var t = A();
	e.operation = function(n) {
		return new t(e.timeouts(n), {
			forever: n && (n.forever || n.retries === Infinity),
			unref: n && n.unref,
			maxRetryTime: n && n.maxRetryTime
		});
	}, e.timeouts = function(e) {
		if (e instanceof Array) return [].concat(e);
		var t = {
			retries: 10,
			factor: 2,
			minTimeout: 1 * 1e3,
			maxTimeout: Infinity,
			randomize: !1
		};
		for (var n in e) t[n] = e[n];
		if (t.minTimeout > t.maxTimeout) throw Error("minTimeout is greater than maxTimeout");
		for (var r = [], i = 0; i < t.retries; i++) r.push(this.createTimeout(i, t));
		return e && e.forever && !r.length && r.push(this.createTimeout(i, t)), r.sort(function(e, t) {
			return e - t;
		}), r;
	}, e.createTimeout = function(e, t) {
		var n = t.randomize ? Math.random() + 1 : 1, r = Math.round(n * Math.max(t.minTimeout, 1) * t.factor ** +e);
		return r = Math.min(r, t.maxTimeout), r;
	}, e.wrap = function(t, n, r) {
		if (n instanceof Array && (r = n, n = null), !r) for (var i in r = [], t) typeof t[i] == "function" && r.push(i);
		for (var a = 0; a < r.length; a++) {
			var o = r[a], s = t[o];
			t[o] = function(r) {
				var i = e.operation(n), a = Array.prototype.slice.call(arguments, 1), o = a.pop();
				a.push(function(e) {
					i.retry(e) || (e && (arguments[0] = i.mainError()), o.apply(this, arguments));
				}), i.attempt(function() {
					r.apply(t, a);
				});
			}.bind(t, s), t[o].options = n;
		}
	};
})), M = /* @__PURE__ */ n((/* @__PURE__ */ e(((e, t) => {
	t.exports = j();
})))()), N = Object.prototype.toString, P = (e) => N.call(e) === "[object Error]", F = /* @__PURE__ */ new Set([
	"network error",
	"Failed to fetch",
	"NetworkError when attempting to fetch resource.",
	"The Internet connection appears to be offline.",
	"Load failed",
	"Network request failed",
	"fetch failed",
	"terminated"
]);
function I(e) {
	return e && P(e) && e.name === "TypeError" && typeof e.message == "string" ? e.message === "Load failed" ? e.stack === void 0 : F.has(e.message) : !1;
}
//#endregion
//#region ../../../node_modules/p-retry/index.js
var L = class extends Error {
	constructor(e) {
		super(), e instanceof Error ? (this.originalError = e, {message: e} = e) : (this.originalError = Error(e), this.originalError.stack = this.stack), this.name = "AbortError", this.message = e;
	}
}, R = (e, t, n) => {
	let r = n.retries - (t - 1);
	return e.attemptNumber = t, e.retriesLeft = r, e;
};
async function z(e, t) {
	return new Promise((n, r) => {
		t = {
			onFailedAttempt() {},
			retries: 10,
			shouldRetry: () => !0,
			...t
		};
		let i = M.operation(t), a = () => {
			i.stop(), r(t.signal?.reason);
		};
		t.signal && !t.signal.aborted && t.signal.addEventListener("abort", a, { once: !0 });
		let o = () => {
			t.signal?.removeEventListener("abort", a), i.stop();
		};
		i.attempt(async (a) => {
			try {
				let t = await e(a);
				o(), n(t);
			} catch (e) {
				try {
					if (!(e instanceof Error)) throw TypeError(`Non-error was thrown: "${e}". You should only throw errors.`);
					if (e instanceof L) throw e.originalError;
					if (e instanceof TypeError && !I(e)) throw e;
					if (R(e, a, t), await t.shouldRetry(e) || (i.stop(), r(e)), await t.onFailedAttempt(e), !i.retry(e)) throw i.mainError();
				} catch (e) {
					R(e, a, t), o(), r(e);
				}
			}
		});
	});
}
//#endregion
//#region src/components/Article/useCreateDraftArticle.ts
function B() {
	let [e, { data: t, loading: n }] = k({ url: `${o.url.knowledgeCdn}/ai/api/beta/conversations/draft_articles` });
	return [(t) => z(() => e({
		refresh: !1,
		csid: t.csid,
		language_id: t.language_id,
		...t.improve ? { improve: t.improve } : {}
	}), { retries: 2 }).then((e) => {
		let { title: n, article_html: r } = e.draft_article;
		return {
			articleContent: r,
			articleName: n,
			collectionId: t.save_draft_article_input?.collection_id || "",
			languageId: t.language_id,
			conversationId: t.csid
		};
	}), {
		data: t,
		loading: n
	}];
}
//#endregion
//#region src/languageStore.ts
var V = "suggestionsSelectedLanguage", H = r({ selectedLanguageId: localStorage.getItem(V) });
i(H, () => {
	H.selectedLanguageId && localStorage.setItem(V, H.selectedLanguageId);
});
var U = (e) => {
	H.selectedLanguageId = e;
};
//#endregion
export { l as a, O as i, H as n, B as r, U as t };

//# sourceMappingURL=languageStore-CczIN6A7.js.map